// eslint-disable-next-line import/prefer-default-export
export async function fetchCreateReview(locale, invitationCode) {
  const response = await fetch(`/api/internal/${locale}/reviews/${invitationCode}/new`, {
    method: 'GET',
    headers: {
      Accept: 'application/json',
    },
  });

  if (!response.ok) {
    throw new Error('no review found');
  }

  const json = await response.json();
  return {
    invitationCode: json.invitation_code,
    booking: {
      accommodationTitle: json.booking.accommodation_title,
      arrival: new Date(json.booking.arrival),
      departure: new Date(json.booking.departure),
      firstName: json.booking.first_name,
    },
  };
}

export async function createGuestReview(locale, invitationCode, ratings, reviewText, npsScore) {
  const body = {
    rating_area: ratings.ratingArea,
    rating_comfort: ratings.ratingComfort,
    rating_value: ratings.ratingValue,
    rating_cleanliness: ratings.ratingCleanliness,
    review_text: reviewText,
    nps_score: npsScore,
  };
  const response = await fetch(
    `/api/internal/${encodeURIComponent(locale)}/reviews/${encodeURIComponent(invitationCode)}`,
    {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(body),
    },
  );

  if (!response.ok) {
    throw new Error('Could not post review');
  }
}
